var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLqdIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#973415;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.5,549V316.3h49.2v192.2h99.8V549H142.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M517.3,432.7c0,25.4-4.8,47-14.4,64.8c-9.6,17.8-22.6,31.4-39.1,40.7c-16.5,9.4-35,14-55.5,14 c-20.7,0-39.2-4.7-55.7-14.1c-16.4-9.4-29.4-23-39-40.8c-9.5-17.8-14.3-39.4-14.3-64.7c0-25.4,4.8-47,14.3-64.8 c9.5-17.8,22.5-31.4,39-40.7c16.4-9.4,35-14,55.7-14c20.5,0,39,4.7,55.5,14c16.5,9.4,29.5,22.9,39.1,40.7 C512.5,385.7,517.3,407.3,517.3,432.7z M467.4,432.7c0-16.4-2.4-30.3-7.3-41.6c-4.9-11.3-11.8-19.8-20.6-25.7 c-8.9-5.8-19.2-8.8-31.1-8.8c-11.9,0-22.3,2.9-31.1,8.8c-8.9,5.8-15.7,14.4-20.6,25.7c-4.9,11.3-7.3,25.2-7.3,41.6 c0,16.4,2.4,30.3,7.3,41.6c4.9,11.3,11.8,19.8,20.6,25.7c8.9,5.8,19.2,8.8,31.1,8.8c11.9,0,22.3-2.9,31.1-8.8 c8.9-5.8,15.7-14.4,20.6-25.7C465,463,467.4,449.1,467.4,432.7z M391.3,468.1h41.8l21,27l20.7,24.1l39,48.9h-45.9l-26.8-33 l-13.8-19.5L391.3,468.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M624.9,549h-82.5V316.3h83.2c23.4,0,43.6,4.6,60.5,13.9c16.9,9.3,29.9,22.6,39,39.9 c9.1,17.3,13.7,38.1,13.7,62.3c0,24.2-4.6,45.1-13.7,62.5c-9.1,17.4-22.2,30.8-39.2,40.1C668.8,544.4,648.5,549,624.9,549z  M591.6,506.9h31.2c14.5,0,26.8-2.6,36.8-7.8c10-5.2,17.5-13.3,22.5-24.2c5-10.9,7.6-25.1,7.6-42.4c0-17.2-2.5-31.2-7.6-42.2 c-5-10.9-12.5-18.9-22.4-24.1c-9.9-5.2-22.2-7.7-36.7-7.7h-31.4V506.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLqdIcon);
export default __webpack_public_path__ + "static/media/lqd_icon.09814869a877eedb33ae3b7f2d96db6b.svg";
export { ForwardRef as ReactComponent };